import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const modify_white = (id, urlOrAddress, description, updateTime) => {
  return api.post(`${ApiEndpointConstants.MODIFYWHITE}`, {
    id,
    urlOrAddress,
    description,
    updateTime,
  });
};
